// Auto-generated mapping of XML components

import AJAX_Applications from "./XML_components/AJAX_Applications.jsx";
import AJAX_ASP from "./XML_components/AJAX_ASP.jsx";
import AJAX_Database from "./XML_components/AJAX_Database.jsx";
import AJAX_Examples from "./XML_components/AJAX_Examples.jsx";
import AJAX_Introduction from "./XML_components/AJAX_Introduction.jsx";
import AJAX_PHP from "./XML_components/AJAX_PHP.jsx";
import AJAX_Request from "./XML_components/AJAX_Request.jsx";
import AJAX_Response from "./XML_components/AJAX_Response.jsx";
import AJAX_XMLFile from "./XML_components/AJAX_XMLFile.jsx";
import AJAX_XMLHttp from "./XML_components/AJAX_XMLHttp.jsx";
import DOM_Accessing from "./XML_components/DOM_Accessing.jsx";
import DOM_AddNodes from "./XML_components/DOM_AddNodes.jsx";
import DOM_Attribute from "./XML_components/DOM_Attribute.jsx";
import DOM_CDATA from "./XML_components/DOM_CDATA.jsx";
import DOM_ChangeNodes from "./XML_components/DOM_ChangeNodes.jsx";
import DOM_CloneNodes from "./XML_components/DOM_CloneNodes.jsx";
import DOM_Comment from "./XML_components/DOM_Comment.jsx";
import DOM_CreateNodes from "./XML_components/DOM_CreateNodes.jsx";
import DOM_Document from "./XML_components/DOM_Document.jsx";
import DOM_Element from "./XML_components/DOM_Element.jsx";
import DOM_Examples from "./XML_components/DOM_Examples.jsx";
import DOM_GetValues from "./XML_components/DOM_GetValues.jsx";
import DOM_Introduction from "./XML_components/DOM_Introduction.jsx";
import DOM_NamedNodeMap from "./XML_components/DOM_NamedNodeMap.jsx";
import DOM_Navigating from "./XML_components/DOM_Navigating.jsx";
import DOM_Node from "./XML_components/DOM_Node.jsx";
import DOM_NodeInfo from "./XML_components/DOM_NodeInfo.jsx";
import DOM_NodeList from "./XML_components/DOM_NodeList.jsx";
import DOM_NodeListRef from "./XML_components/DOM_NodeListRef.jsx";
import DOM_Nodes from "./XML_components/DOM_Nodes.jsx";
import DOM_NodeTypes from "./XML_components/DOM_NodeTypes.jsx";
import DOM_Parser from "./XML_components/DOM_Parser.jsx";
import DOM_RemoveNodes from "./XML_components/DOM_RemoveNodes.jsx";
import DOM_ReplaceNodes from "./XML_components/DOM_ReplaceNodes.jsx";
import DOM_Text from "./XML_components/DOM_Text.jsx";
import DOM_Traversing from "./XML_components/DOM_Traversing.jsx";
import DOM_XMLHttpRequest from "./XML_components/DOM_XMLHttpRequest.jsx";
import DTD_Attributes from "./XML_components/DTD_Attributes.jsx";
import DTD_BuildingBlocks from "./XML_components/DTD_BuildingBlocks.jsx";
import DTD_Elements from "./XML_components/DTD_Elements.jsx";
import DTD_ElementsVsAttr from "./XML_components/DTD_ElementsVsAttr.jsx";
import DTD_Entities from "./XML_components/DTD_Entities.jsx";
import DTD_Examples from "./XML_components/DTD_Examples.jsx";
import DTD_Introduction from "./XML_components/DTD_Introduction.jsx";
import XML_Attributes from "./XML_components/XML_Attributes.jsx";
import XML_Certificate from "./XML_components/XML_Certificate.jsx";
import XML_Display from "./XML_components/XML_Display.jsx";
import XML_DOM from "./XML_components/XML_DOM.jsx";
import XML_DTD from "./XML_components/XML_DTD.jsx";
import XML_Elements from "./XML_components/XML_Elements.jsx";
import XML_Examples from "./XML_components/XML_Examples.jsx";
import XML_HOME from "./XML_components/XML_HOME.jsx";
import XML_HowToUse from "./XML_components/XML_HowToUse.jsx";
import XML_HttpRequest from "./XML_components/XML_HttpRequest.jsx";
import XML_Introduction from "./XML_components/XML_Introduction.jsx";
import XML_Namespaces from "./XML_components/XML_Namespaces.jsx";
import XML_Parser from "./XML_components/XML_Parser.jsx";
import XML_Quiz from "./XML_components/XML_Quiz.jsx";
import XML_RDF from "./XML_components/XML_RDF.jsx";
import XML_RSS from "./XML_components/XML_RSS.jsx";
import XML_Schema from "./XML_components/XML_Schema.jsx";
import XML_Server from "./XML_components/XML_Server.jsx";
import XML_Services from "./XML_components/XML_Services.jsx";
import XML_SOAP from "./XML_components/XML_SOAP.jsx";
import XML_StudyPlan from "./XML_components/XML_StudyPlan.jsx";
import XML_Syllabus from "./XML_components/XML_Syllabus.jsx";
import XML_Syntax from "./XML_components/XML_Syntax.jsx";
import XML_Tree from "./XML_components/XML_Tree.jsx";
import XML_Validator from "./XML_components/XML_Validator.jsx";
import XML_WSDL from "./XML_components/XML_WSDL.jsx";
import XML_XLink from "./XML_components/XML_XLink.jsx";
import XML_XPath from "./XML_components/XML_XPath.jsx";
import XML_XQuery from "./XML_components/XML_XQuery.jsx";
import XML_XSLT from "./XML_components/XML_XSLT.jsx";
import XPath_Axes from "./XML_components/XPath_Axes.jsx";
import XPath_Examples from "./XML_components/XPath_Examples.jsx";
import XPath_Introduction from "./XML_components/XPath_Introduction.jsx";
import XPath_Nodes from "./XML_components/XPath_Nodes.jsx";
import XPath_Operators from "./XML_components/XPath_Operators.jsx";
import XPath_Syntax from "./XML_components/XPath_Syntax.jsx";
import XQuery_Add from "./XML_components/XQuery_Add.jsx";
import XQuery_Example from "./XML_components/XQuery_Example.jsx";
import XQuery_FLWOR from "./XML_components/XQuery_FLWOR.jsx";
import XQuery_Functions from "./XML_components/XQuery_Functions.jsx";
import XQuery_HTML from "./XML_components/XQuery_HTML.jsx";
import XQuery_Introduction from "./XML_components/XQuery_Introduction.jsx";
import XQuery_Select from "./XML_components/XQuery_Select.jsx";
import XQuery_Syntax from "./XML_components/XQuery_Syntax.jsx";
import XQuery_Terms from "./XML_components/XQuery_Terms.jsx";
import XSD_Any from "./XML_components/XSD_Any.jsx";
import XSD_AnyAttribute from "./XML_components/XSD_AnyAttribute.jsx";
import XSD_Attributes from "./XML_components/XSD_Attributes.jsx";
import XSD_ComplexElements from "./XML_components/XSD_ComplexElements.jsx";
import XSD_DateTime from "./XML_components/XSD_DateTime.jsx";
import XSD_Elements from "./XML_components/XSD_Elements.jsx";
import XSD_ElementsOnly from "./XML_components/XSD_ElementsOnly.jsx";
import XSD_Empty from "./XML_components/XSD_Empty.jsx";
import XSD_Example from "./XML_components/XSD_Example.jsx";
import XSD_HowTo from "./XML_components/XSD_HowTo.jsx";
import XSD_Indicators from "./XML_components/XSD_Indicators.jsx";
import XSD_Introduction from "./XML_components/XSD_Introduction.jsx";
import XSD_Misc from "./XML_components/XSD_Misc.jsx";
import XSD_Mixed from "./XML_components/XSD_Mixed.jsx";
import XSD_Numeric from "./XML_components/XSD_Numeric.jsx";
import XSD_Reference from "./XML_components/XSD_Reference.jsx";
import XSD_Restrictions from "./XML_components/XSD_Restrictions.jsx";
import XSD_SchemaTag from "./XML_components/XSD_SchemaTag.jsx";
import XSD_String from "./XML_components/XSD_String.jsx";
import XSD_Substitution from "./XML_components/XSD_Substitution.jsx";
import XSD_TextOnly from "./XML_components/XSD_TextOnly.jsx";
import XSLT_Apply from "./XML_components/XSLT_Apply.jsx";
import XSLT_Choose from "./XML_components/XSLT_Choose.jsx";
import XSLT_Client from "./XML_components/XSLT_Client.jsx";
import XSLT_EditXML from "./XML_components/XSLT_EditXML.jsx";
import XSLT_Elements from "./XML_components/XSLT_Elements.jsx";
import XSLT_Examples from "./XML_components/XSLT_Examples.jsx";
import XSLT_ForEach from "./XML_components/XSLT_ForEach.jsx";
import XSLT_If from "./XML_components/XSLT_If.jsx";
import XSLT_Introduction from "./XML_components/XSLT_Introduction.jsx";
import XSLT_Server from "./XML_components/XSLT_Server.jsx";
import XSLT_Sort from "./XML_components/XSLT_Sort.jsx";
import XSLT_Template from "./XML_components/XSLT_Template.jsx";
import XSLT_Transform from "./XML_components/XSLT_Transform.jsx";
import XSLT_ValueOf from "./XML_components/XSLT_ValueOf.jsx";
import XSLT_XPathFunctions from "./XML_components/XSLT_XPathFunctions.jsx";
import XSL_Languages from "./XML_components/XSL_Languages.jsx";

const xmlComponentsMap = {
  "<AJAX_Applications />": AJAX_Applications,
  "<AJAX_ASP />": AJAX_ASP,
  "<AJAX_Database />": AJAX_Database,
  "<AJAX_Examples />": AJAX_Examples,
  "<AJAX_Introduction />": AJAX_Introduction,
  "<AJAX_PHP />": AJAX_PHP,
  "<AJAX_Request />": AJAX_Request,
  "<AJAX_Response />": AJAX_Response,
  "<AJAX_XMLFile />": AJAX_XMLFile,
  "<AJAX_XMLHttp />": AJAX_XMLHttp,
  "<DOM_Accessing />": DOM_Accessing,
  "<DOM_AddNodes />": DOM_AddNodes,
  "<DOM_Attribute />": DOM_Attribute,
  "<DOM_CDATA />": DOM_CDATA,
  "<DOM_ChangeNodes />": DOM_ChangeNodes,
  "<DOM_CloneNodes />": DOM_CloneNodes,
  "<DOM_Comment />": DOM_Comment,
  "<DOM_CreateNodes />": DOM_CreateNodes,
  "<DOM_Document />": DOM_Document,
  "<DOM_Element />": DOM_Element,
  "<DOM_Examples />": DOM_Examples,
  "<DOM_GetValues />": DOM_GetValues,
  "<DOM_Introduction />": DOM_Introduction,
  "<DOM_NamedNodeMap />": DOM_NamedNodeMap,
  "<DOM_Navigating />": DOM_Navigating,
  "<DOM_Node />": DOM_Node,
  "<DOM_NodeInfo />": DOM_NodeInfo,
  "<DOM_NodeList />": DOM_NodeList,
  "<DOM_NodeListRef />": DOM_NodeListRef,
  "<DOM_Nodes />": DOM_Nodes,
  "<DOM_NodeTypes />": DOM_NodeTypes,
  "<DOM_Parser />": DOM_Parser,
  "<DOM_RemoveNodes />": DOM_RemoveNodes,
  "<DOM_ReplaceNodes />": DOM_ReplaceNodes,
  "<DOM_Text />": DOM_Text,
  "<DOM_Traversing />": DOM_Traversing,
  "<DOM_XMLHttpRequest />": DOM_XMLHttpRequest,
  "<DTD_Attributes />": DTD_Attributes,
  "<DTD_BuildingBlocks />": DTD_BuildingBlocks,
  "<DTD_Elements />": DTD_Elements,
  "<DTD_ElementsVsAttr />": DTD_ElementsVsAttr,
  "<DTD_Entities />": DTD_Entities,
  "<DTD_Examples />": DTD_Examples,
  "<DTD_Introduction />": DTD_Introduction,
  "<XML_Attributes />": XML_Attributes,
  "<XML_Certificate />": XML_Certificate,
  "<XML_Display />": XML_Display,
  "<XML_DOM />": XML_DOM,
  "<XML_DTD />": XML_DTD,
  "<XML_Elements />": XML_Elements,
  "<XML_Examples />": XML_Examples,
  "<XML_HOME />": XML_HOME,
  "<XML_HowToUse />": XML_HowToUse,
  "<XML_HttpRequest />": XML_HttpRequest,
  "<XML_Introduction />": XML_Introduction,
  "<XML_Namespaces />": XML_Namespaces,
  "<XML_Parser />": XML_Parser,
  "<XML_Quiz />": XML_Quiz,
  "<XML_RDF />": XML_RDF,
  "<XML_RSS />": XML_RSS,
  "<XML_Schema />": XML_Schema,
  "<XML_Server />": XML_Server,
  "<XML_Services />": XML_Services,
  "<XML_SOAP />": XML_SOAP,
  "<XML_StudyPlan />": XML_StudyPlan,
  "<XML_Syllabus />": XML_Syllabus,
  "<XML_Syntax />": XML_Syntax,
  "<XML_Tree />": XML_Tree,
  "<XML_Validator />": XML_Validator,
  "<XML_WSDL />": XML_WSDL,
  "<XML_XLink />": XML_XLink,
  "<XML_XPath />": XML_XPath,
  "<XML_XQuery />": XML_XQuery,
  "<XML_XSLT />": XML_XSLT,
  "<XPath_Axes />": XPath_Axes,
  "<XPath_Examples />": XPath_Examples,
  "<XPath_Introduction />": XPath_Introduction,
  "<XPath_Nodes />": XPath_Nodes,
  "<XPath_Operators />": XPath_Operators,
  "<XPath_Syntax />": XPath_Syntax,
  "<XQuery_Add />": XQuery_Add,
  "<XQuery_Example />": XQuery_Example,
  "<XQuery_FLWOR />": XQuery_FLWOR,
  "<XQuery_Functions />": XQuery_Functions,
  "<XQuery_HTML />": XQuery_HTML,
  "<XQuery_Introduction />": XQuery_Introduction,
  "<XQuery_Select />": XQuery_Select,
  "<XQuery_Syntax />": XQuery_Syntax,
  "<XQuery_Terms />": XQuery_Terms,
  "<XSD_Any />": XSD_Any,
  "<XSD_AnyAttribute />": XSD_AnyAttribute,
  "<XSD_Attributes />": XSD_Attributes,
  "<XSD_ComplexElements />": XSD_ComplexElements,
  "<XSD_DateTime />": XSD_DateTime,
  "<XSD_Elements />": XSD_Elements,
  "<XSD_ElementsOnly />": XSD_ElementsOnly,
  "<XSD_Empty />": XSD_Empty,
  "<XSD_Example />": XSD_Example,
  "<XSD_HowTo />": XSD_HowTo,
  "<XSD_Indicators />": XSD_Indicators,
  "<XSD_Introduction />": XSD_Introduction,
  "<XSD_Misc />": XSD_Misc,
  "<XSD_Mixed />": XSD_Mixed,
  "<XSD_Numeric />": XSD_Numeric,
  "<XSD_Reference />": XSD_Reference,
  "<XSD_Restrictions />": XSD_Restrictions,
  "<XSD_SchemaTag />": XSD_SchemaTag,
  "<XSD_String />": XSD_String,
  "<XSD_Substitution />": XSD_Substitution,
  "<XSD_TextOnly />": XSD_TextOnly,
  "<XSLT_Apply />": XSLT_Apply,
  "<XSLT_Choose />": XSLT_Choose,
  "<XSLT_Client />": XSLT_Client,
  "<XSLT_EditXML />": XSLT_EditXML,
  "<XSLT_Elements />": XSLT_Elements,
  "<XSLT_Examples />": XSLT_Examples,
  "<XSLT_ForEach />": XSLT_ForEach,
  "<XSLT_If />": XSLT_If,
  "<XSLT_Introduction />": XSLT_Introduction,
  "<XSLT_Server />": XSLT_Server,
  "<XSLT_Sort />": XSLT_Sort,
  "<XSLT_Template />": XSLT_Template,
  "<XSLT_Transform />": XSLT_Transform,
  "<XSLT_ValueOf />": XSLT_ValueOf,
  "<XSLT_XPathFunctions />": XSLT_XPathFunctions,
  "<XSL_Languages />": XSL_Languages,
};

export default xmlComponentsMap;
